import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import { takeInitials } from 'Utils';
import moment from 'moment';
import { LinearProgress } from '@material-ui/core';

const Title = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.secondary.main};
  font-size: 0.875rem;
`;

const Value = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-left: 0.5rem;
`;

const Image = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  margin: 0 ${rhythm(0.25)};
`;

const Row = styled.div`
  text-align: right;
`;

const InnerRow = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
`;

const Avatar = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.blue.light};
  color: #fff;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${rhythm(0.25)};
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
`;

const ProgressContainer = styled.div`
  padding: ${rhythm(0.5)} 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const BarContainer = styled.div`
  flex: 0 0 60%;
`;

const RemainingTime = styled.div`
  font-size: 0.875rem;
  text-align: right;
  flex: 0 0 40%;
`;

const IssuedBy = ({ name, img, date }) => (
  <div>
    <Row>
      <InnerRow>
        <Title>Issued by:</Title>
        {!img ? <Avatar>{takeInitials(name)}</Avatar> : <Image src={img} />}
        <Value>{name}</Value>
      </InnerRow>
    </Row>
    <Row>
      <InnerRow>
        <Title>Issued on:</Title>
        <Value>{moment(date).format('DD MMM YYYY')}</Value>
      </InnerRow>
    </Row>
    {/* <ProgressContainer>
      <BarContainer>
        <LinearProgress variant="determinate" value={80} />
      </BarContainer>
      <RemainingTime>9d 8h 32min</RemainingTime>
    </ProgressContainer> */}
  </div>
);

export default IssuedBy;
